export default "__VITE_ASSET__DlYydsS$__"